import xss from "xss";

class KonditionenItem {
  constructor(
    kennziffer,
    bezeichnung,
    konditionen,
    preis,
    kurs,
    defaultWerte,
    editierbar,
    listKeys,
    row,
    originalWerte,
    stufenWert,
    changed,
    einheit,
    mwst,
  ) {
    this.kennziffer = Number(kennziffer);
    this.bezeichnung = xss(bezeichnung);
    this.stufenWert = Number(stufenWert);
    this.mwst = !isNaN(mwst) ? Number(mwst) : 0;
    const edit = Array.isArray(editierbar)
      ? editierbar.map((val) => {
        return !!String(val).match(/^(J|TRUE)$/i);
      })
      : [];
    this.preis = Array.isArray(preis)
      ? preis.map((val) => {
        return !isNaN(val) ? Number(val) : 0;
      })
      : [];
    this.kurs = Array.isArray(kurs)
      ? kurs.map((val) => {
        return !isNaN(val) ? Number(val) : 0;
      })
      : [];
    defaultWerte = Array.isArray(defaultWerte)
      ? defaultWerte.map((val) => {
        return !isNaN(val) ? Number(val) : 0;
      })
      : [];
    if (Array.isArray(originalWerte)) {
      originalWerte = originalWerte.map((val, idx) => {
        if (!isNaN(val)) return Number(val);
        if (Array.isArray(konditionen) && !isNaN(konditionen[idx])) {
          return Number(konditionen[idx]);
        }
        return 0;
      });
    } else {
      originalWerte = Array.isArray(konditionen)
        ? this.konditionen
        : [];
    }
    changed = Array.isArray(changed)
      ? changed.map(c => !!c)
      : [];
    einheit = Array.isArray(einheit)
      ? einheit.map(e => String(e))
      : [];
    this.row = !isNaN(row) ? Number(row) : null;
    this.konditionen = Array.isArray(konditionen)
      ? konditionen.map((val, idx) => {
        return {
          col: idx,
          row: this.row,
          label: listKeys.headers[idx] || "",
          field: listKeys.konditionen[idx],
          editierbar: edit[idx],
          defaultWert: defaultWerte[idx],
          originalWert: originalWerte[idx],
          value: !isNaN(val) ? Number(val) : 0,
          changed: !!changed[idx],
          originalChanged: !!changed[idx],
          einheit: einheit[idx] || "%",
          isMaKond: listKeys.isMaKond[idx],
        };
      })
      : [];
    this.listKeys = listKeys || {};
    if (!listKeys || !listKeys.preis) this.preis = [];
    if (!listKeys || !listKeys.kurs) this.kurs = [];
    this.changed = changed.reduce((prevValue, c) => prevValue || c, false);

    this.setKondition = this.setKondition.bind(this);
  }

  setRow(row) {
    this.row = row;
    this.konditionen.forEach(k => {
      k.row = row;
    });
  }

  getKondition(col) {
    return this.kondition[col];
  }

  setKondition(value, col) {
    if (isNaN(col) || !this.konditionen[col] || !this.konditionen[col].editierbar) return;
    // reset if value is not numeric
    if (isNaN(value)) value = this.konditionen[col].originalWert;
    this.konditionen[col].value = Number(value);
    this.konditionen[col].changed = true;
    this.changed = this.konditionen.reduce((prevValue, k) => prevValue || k.changed, false);
  }

  resetKondition(col) {
    if (isNaN(col) || !this.konditionen[col] || !this.konditionen[col].editierbar) return;
    let value = this.konditionen[col] ? this.konditionen[col].originalWert : 0;
    this.konditionen[col].value = value;
    this.konditionen[col].changed = this.konditionen[col].originalChanged;
  }

  isDirty(col) {
    if (!isNaN(col) && this.konditionen[col]) {
      return this.konditionen[col].value !== this.konditionen[col].originalWert;
    }
    return !!this.konditionen.find(k => k.value !== k.originalWert);
  }

  toJsonForPayload() {
    if (1 == 0 && !this.isDirty()) return null;
    let attribute = {};
    this.listKeys.editierbar.forEach((key, idx) => {
      attribute[key] = this.konditionen[idx].editierbar ? "J" : "N";
    });
    this.listKeys.konditionen.forEach((key, idx) => {
      attribute[key] = this.konditionen[idx].value;
    });
    if (this.preis.length) {
      this.listKeys.preis.forEach((key, idx) => {
        attribute[key] = this.preis[idx];
      });
    }
    if (this.kurs.length) {
      this.listKeys.kurs.forEach((key, idx) => {
        attribute[key] = this.kurs[idx];
      });
    }
    if (this.stufenWert) {
      attribute["stufenWert"] = this.stufenWert;
    }
    return {
      kennziffer: String(this.kennziffer),
      bezeichnung: xss(this.bezeichnung),
      ...attribute
    };
  }

  toJsonForUpdate(col) {
    if (1 == 0 && !this.isDirty()) return null;
    let attribute = {};
    let key = this.listKeys.konditionen[col];
    attribute[key] = this.konditionen[col].value;
    if (this.stufenWert) {
      attribute["stufenWert"] = this.stufenWert;
    }
    return {
      kennziffer: String(this.kennziffer),
      ...attribute
    };
  }
}

KonditionenItem.create = (data, listKeys, row) => {
  if (!data || !listKeys) return null;
  const originalKonditionen = Array.isArray(data.originalWerte)
    ? data.originalWerte
    : Array.isArray(data.konditionen)
      ? data.konditionen
      : [];

    const item = new KonditionenItem(
      data.kennziffer,
      data.bezeichnung,
      data.konditionen,
      data.preis,
      data.kurs,
      data.defaultWerte,
      data.editierbar,
      listKeys,
      row,
      originalKonditionen,
      data.stufenWert,
      data.changed,
      data.einheit,
      data.mwst
    );
  return item;
};

KonditionenItem.prototype.clone = (item) => {
  let self = this;
  // check kompiler error
  if (!self) self = item;
  if (!self || !Array.isArray(self.konditionen)) self = { konditionen: [] };
  return new KonditionenItem(
    self.kennziffer,
    self.bezeichnug,
    self.konditionen.map(k => k.value),
    self.preis,
    self.kurs,
    self.konditionen.map(k => k.defaultWert),
    self.konditionen.map(k => k.editierbar),
    self.listKeys,
    self.row,
    self.konditionen.map(k => k.originalWert),
    self.stufenWert,
    self.changed
  );
};

export default KonditionenItem;
